export { BsModalRef } from './bs-modal-ref.service';
export { ModalBackdropOptions } from './modal-backdrop.options';
export { ModalContainerComponent } from './modal-container.component';
export { ModalBackdropComponent } from './modal-backdrop.component';
export { ModalOptions } from './modal-options.class';
export { ModalDirective } from './modal.directive';
export { ModalModule } from './modal.module';
export { BsModalService } from './bs-modal.service';



// WEBPACK FOOTER //
// ../../.tmp/modal/index.ts